var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScholarship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3327 9.50033C25.3327 6.51416 25.3327 5.02266 24.4048 4.09483C23.477 3.16699 21.9855 3.16699 18.9993 3.16699C16.0132 3.16699 14.5217 3.16699 13.5938 4.09483C12.666 5.02266 12.666 6.51416 12.666 9.50033M3.16602 22.167C3.16602 16.1962 3.16602 13.2101 5.02168 11.356C6.87735 9.50191 9.86193 9.50033 15.8327 9.50033H22.166C28.1368 9.50033 31.1229 9.50033 32.977 11.356C34.8311 13.2117 34.8327 16.1962 34.8327 22.167C34.8327 28.1377 34.8327 31.1239 32.977 32.978C31.1213 34.8321 28.1368 34.8337 22.166 34.8337H15.8327C9.86193 34.8337 6.87577 34.8337 5.02168 32.978C3.1676 31.1223 3.16602 28.1377 3.16602 22.167Z",
    stroke: "#367FFF",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9987 27.4446C20.7483 27.4446 22.1654 26.2634 22.1654 24.8067C22.1654 23.3501 20.7483 22.1673 18.9987 22.1673C17.2491 22.1673 15.832 20.9862 15.832 19.5279C15.832 18.0712 17.2491 16.8901 18.9987 16.8901M18.9987 27.4446C17.2491 27.4446 15.832 26.2634 15.832 24.8067M18.9987 27.4446V28.5007M18.9987 16.8901V15.834M18.9987 16.8901C20.7483 16.8901 22.1654 18.0712 22.1654 19.5279",
    stroke: "#367FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScholarship);
export default __webpack_public_path__ + "static/media/icon-scholarship.6a6a253d20edb5b3533a57e4be350ca9.svg";
export { ForwardRef as ReactComponent };